import type { Transform } from "./types";

export const escapeJsonNewLine: Transform<string> = (s) => s.replace(/\\n/g, "\n");

export const sanitizeHtmlTags: Transform<string> = (s) => {
    return s.replace(/<\/?[a-z][\s\S]*?>/gi, "");
};

const NAMED_HTML_ENTITIES: Readonly<Record<string, string>> = {
    nbsp: " ",
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"',
    apos: "'",
};

const HTML_ENTITY_PATTERN = /&(#(?:x[0-9a-f]+|[0-9]+)|[a-z]+);/gi;

const isValidCodePoint = (codePoint: number): boolean =>
    Number.isInteger(codePoint) && codePoint >= 0 && codePoint <= 0x10ffff;

const decodeHtmlEntity = (entity: string): string | undefined => {
    if (entity.startsWith("#x")) {
        const codePoint = Number.parseInt(entity.slice(2), 16);

        return isValidCodePoint(codePoint) ? String.fromCodePoint(codePoint) : undefined;
    }

    if (entity.startsWith("#")) {
        const codePoint = Number.parseInt(entity.slice(1), 10);

        return isValidCodePoint(codePoint) ? String.fromCodePoint(codePoint) : undefined;
    }

    return NAMED_HTML_ENTITIES[entity.toLowerCase()];
};

/** Decodes common HTML entities left behind after tag stripping (e.g. signal name copy for chips). */
export const decodeHtmlEntities: Transform<string> = (s) =>
    s.replace(HTML_ENTITY_PATTERN, (match, entity: string) => decodeHtmlEntity(entity) ?? match);
